var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/icon/warning/warning.svg"),"alt":"warning"}}),_c('div',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-body2"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }